<template>
  <div :id="post.id" class="tumblr-post row shadow-sm rounded my-4 bg-light text-break">


    <div class="col py-3">
      <div v-if="post.type === 'video'" class="tumblr-post__video">
        <span v-if="!post.player[0].embed_code">
          <a :href="post.post_url" target="_blank">
            View video on tumblr
          </a>
        </span>
        <span :rawHtml="post.player[0].embed_code" v-else>
        </span>
      </div>

      <div v-else-if="post.type === 'photo'" class="tumblr-post__photo">
        <img :src="post.photos[0].original_size.url" class="w-100 pb-4">
      </div>

      <div v-else-if="post.type === 'text'" class="tumblr-post__text">
        <span v-html="post.body">
        </span>
      </div>

      <div v-else-if="post.type === 'link'" class="tumblr-post__link text-center">
        <a :href="post.url" target="_blank">
          <img v-if="post.link_image" :src="post.link_image"/>

          <div class="text-center font-weight-bold py-3">{{ post.title }}</div>
        </a>
      </div>

      <div v-else-if="post.type === 'answer'" class="tumblr-post__answer">
        <div class="bg-light py-3 px-3">
          <div class="row pb-2">
            <div class="col">
              <small><b>Question: </b></small>
            </div>
          </div>
          <div class="row">
            <div class="col text-center">
              {{ post.question }}
            </div>
          </div>
        </div>

        <div class="bg-light pt-3 px-3">
          <div class="row">
            <div class="col">
              <small><b>Answer</b></small>
            </div>
          </div>
          <div class="row">
            <div class="col text-center" v-html="post.answer">
          </div>
          </div>
        </div>
      </div>


      <div class="row" v-if="post.caption">
        <div class="col">
          <span v-html="post.caption">
          </span>
        </div>

      </div>

      <hr v-if="show_tags && post.tags.length > 0" />

      <div v-if="show_tags && post.tags.length > 0">
        <div class="d-flex flex-wrap justify-content-center">
            <a target="_blank"
                class="mx-2"
                :href="tag_link(tag)"
                :key="tag"
                v-for="tag in post.tags">
              <small>#{{ tag }}</small>
            </a>
        </div>
      </div>

      <hr />

      <div class="d-flex justify-content-between">
        <div class="mx-3">
          <small v-if="show_notes">{{ post.note_count }} Notes</small>
        </div>
        <div class="mx-3">
          <small><a :href="post.post_url" target="_blank">
            <font-awesome-icon icon="link" />
          </a></small>
        </div>
      </div>


    </div>

  </div>
</template>


<script>
export default {
  name: 'TumblrPost',
  components: {},
  data() {
    return {

    };
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    show_notes: {
      type: Boolean,
      default: true,
    },
    show_tags: {
      type: Boolean,
      default: true,
    },
  },
  // mounted() {},
  methods: {
    tag_link(tag) {
      const tagSlug = tag.replace(/ /g, '-');
      return `http://${this.post.blog.name}.tumblr.com/tagged/${tagSlug}`;
    },
  },
  // methods: {}
};
</script>


<style lang="scss">
.tumblr-post {
  figure {
    display: block;
    text-align: center;

    img {
      max-width: 100% !important;
      height: inherit;
    }

  }

  &__link {
    img {
      max-width: 100% !important;
      height: inherit;
    }
  }
}
</style>
